/**
 * 2020/4/2 - 11:42
 * @author jiabinbin
 * @Email 425605679@qq.com
 * @Description:
 *
 */
export default {
  namespaced: true,
  state: {
    cancelTokenArr: [] // 取消请求token数组
  },
  mutations: {
    PUSH_TOKEN (state, payload) {
      state.cancelTokenArr.push(payload.cancelToken)
    },
    CLEAR_TOKEN ({ cancelTokenArr }) {
      cancelTokenArr.forEach(item => {
        item('路由跳转取消请求')
      })
      cancelTokenArr = []
    }
  }
}
